// PRODUCTION — flow editor right column (group settings or step config)
import React from 'react'
import tw from 'twin.macro'
import { FLOW_EDITOR_FEATURE_FLAGS } from 'src/constants/flowEditorFeatureFlags'
import { useFlowEditorContext } from 'src/pages/admin/flow-editor/context/useFlowEditorContext'
import { FlowEditorStepGroupSettingsPanel } from '../FlowEditorStepGroupSettingsPanel'
import { StepConfigPanel } from '../StepConfigPanel'

export function FlowEditorConfigPanel() {
  const {
    groupInsurancePolicySelectOptions,
    handleCollectDataTemplateStepLabelChange,
    handleConfigChange,
    handleGroupDelayedChange,
    handleGroupInsurancePolicyChange,
    handleGroupLabelChange,
    handleMoveStep,
    handleMoveStepGroup,
    handleRemoveGroup,
    handleRetroactiveCollectRequiredChange,
    handleAdvancedStepRowFieldChange,
    handleSyncInsurancePolicySteps,
    insuranceSyncStepsError,
    selectedGroupConfigId,
    selectedGroupInsuranceSyncDisabled,
    selectedGroupPanelProps,
    selectedStep,
    selectedStepGroupOrder,
  } = useFlowEditorContext()

  return (
    <div css={tw`min-h-0 min-w-0 flex-1 overflow-y-auto`}>
      {selectedGroupPanelProps && selectedGroupConfigId ? (
        <FlowEditorStepGroupSettingsPanel
          key={selectedGroupConfigId}
          canMoveDown={selectedGroupPanelProps.canMoveDown}
          canMoveUp={selectedGroupPanelProps.canMoveUp}
          canRemoveGroup={selectedGroupPanelProps.canRemoveGroup}
          delayed={selectedGroupPanelProps.delayed}
          groupOrdinal={selectedGroupPanelProps.groupOrdinal}
          insurancePolicyId={selectedGroupPanelProps.insurancePolicyId}
          insurancePolicyOptions={groupInsurancePolicySelectOptions}
          insurancePolicyReadOnly={false}
          insuranceSyncStepsDisabled={selectedGroupInsuranceSyncDisabled}
          label={selectedGroupPanelProps.label}
          showInsurancePolicySelector={selectedGroupPanelProps.showInsurancePolicySelector}
          totalGroups={selectedGroupPanelProps.totalGroups}
          onDelayedChange={(d) => handleGroupDelayedChange(selectedGroupConfigId, d)}
          onInsurancePolicyChange={(policyId) =>
            handleGroupInsurancePolicyChange(selectedGroupConfigId, policyId)
          }
          onLabelChange={(label) => handleGroupLabelChange(selectedGroupConfigId, label)}
          onMoveGroup={(dir) => handleMoveStepGroup(selectedGroupConfigId, dir)}
          onRemoveGroup={() => handleRemoveGroup(selectedGroupConfigId)}
          insuranceSyncStepsError={insuranceSyncStepsError}
          onSyncInsurancePolicySteps={handleSyncInsurancePolicySteps}
        />
      ) : (
        <StepConfigPanel
          step={selectedStep}
          index={selectedStepGroupOrder !== null ? selectedStepGroupOrder.indexInGroup : undefined}
          total={selectedStepGroupOrder !== null ? selectedStepGroupOrder.totalInGroup : undefined}
          onMove={FLOW_EDITOR_FEATURE_FLAGS.allowReorderSteps ? handleMoveStep : undefined}
          onConfigChange={handleConfigChange}
          onRetroactiveCollectRequiredChange={handleRetroactiveCollectRequiredChange}
          onAdvancedStepRowFieldChange={handleAdvancedStepRowFieldChange}
          onCollectDataTemplateStepLabelChange={handleCollectDataTemplateStepLabelChange}
        />
      )}
    </div>
  )
}
